const MM_DD_YYYY = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export const POLICY_DATE_FORMAT_MESSAGE = "must be a valid MM/DD/YYYY date";

function isRealCalendarDate(year: number, month: number, day: number): boolean {
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

/**
 * A date as an ACORD blank prints it: MM/DD/YYYY.
 *
 * CSR-2058 — the two inputs are DC's ISO policy dates and the selection modal's
 * `<input type="date">` value, both `YYYY-MM-DD`; an already-formatted
 * MM/DD/YYYY passes through. Anything else (null, "", a bad scrape's
 * "MM/DD/YYYY" placeholder) becomes an empty blank rather than an invented date,
 * per CSR-1768.
 *
 * Deliberately string-to-string: routing an ISO date through `new Date()` and
 * back parses it as UTC midnight and formats it in the server's timezone, which
 * silently reports the previous day anywhere west of UTC.
 */
export function formatMonthDayYear(value: string | null | undefined): string {
  if (!value) return "";
  if (!isValidPolicyDate(value)) return "";
  const iso = value.match(ISO_DATE);
  return iso ? `${iso[2]}/${iso[3]}/${iso[1]}` : value;
}

// Accepts canonical MM/DD/YYYY and ISO YYYY-MM-DD — the standalone policy pages
// submit ISO from a native <input type="date">. Rejects packed digits
// ("08222026"), impossible dates ("2027-29-01"), and placeholder text.
export function isValidPolicyDate(value: string): boolean {
  const mdy = value.match(MM_DD_YYYY);
  if (mdy)
    return isRealCalendarDate(Number(mdy[3]), Number(mdy[1]), Number(mdy[2]));
  const iso = value.match(ISO_DATE);
  if (iso)
    return isRealCalendarDate(Number(iso[1]), Number(iso[2]), Number(iso[3]));
  return false;
}
